import ProductListPanel from './productListPanel.container';

export default ProductListPanel